// extracted by mini-css-extract-plugin
module.exports = {"hm-colors":"#66000D,#A50F15,#CB191D,#EF3B2C,#FB6A4A,#FC9272,#FCBBA1","hm-opacity":".95","fz-color":"#FFEB00","fz-opacity":".6"};